module.exports = __webpack_public_path__ + "static/media/degerforsvapen.6cddb4ef.png";